'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

const POPULAR_ROUTES = [
  { id: 'route-jfk-mad', from: 'New York', fromCode: 'JFK', to: 'Madrid', toCode: 'MAD', price: 389, flag: '🇪🇸' },
  { id: 'route-lax-lhr', from: 'Los Angeles', fromCode: 'LAX', to: 'London', toCode: 'LHR', price: 512, flag: '🇬🇧' },
  { id: 'route-jfk-cdg', from: 'New York', fromCode: 'JFK', to: 'Paris', toCode: 'CDG', price: 447, flag: '🇫🇷' },
  { id: 'route-ord-fra', from: 'Chicago', fromCode: 'ORD', to: 'Frankfurt', toCode: 'FRA', price: 531, flag: '🇩🇪' },
  { id: 'route-mia-gru', from: 'Miami', fromCode: 'MIA', to: 'São Paulo', toCode: 'GRU', price: 618, flag: '🇧🇷' },
  { id: 'route-lax-nrt', from: 'Los Angeles', fromCode: 'LAX', to: 'Tokyo', toCode: 'NRT', price: 743, flag: '🇯🇵' },
  { id: 'route-jfk-dxb', from: 'New York', fromCode: 'JFK', to: 'Dubai', toCode: 'DXB', price: 891, flag: '🇦🇪' },
  { id: 'route-sfo-sin', from: 'San Francisco', fromCode: 'SFO', to: 'Singapore', toCode: 'SIN', price: 824, flag: '🇸🇬' },
];

export default function PopularRoutes() {
  const router = useRouter();

  const handleRouteClick = (route: typeof POPULAR_ROUTES[0]) => {
    const today = new Date();
    const dep = new Date(today);
    dep.setDate(dep.getDate() + 30);
    const ret = new Date(dep);
    ret.setDate(ret.getDate() + 7);

    const fmt = (d: Date) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

    const query = new URLSearchParams({
      origin: `${route.from} (${route.fromCode})`,
      originCode: route.fromCode,
      destination: `${route.to} (${route.toCode})`,
      destinationCode: route.toCode,
      departureDate: fmt(dep),
      returnDate: fmt(ret),
      tripType: 'round_trip',
      adults: '1',
      children: '0',
      infants: '0',
      cabinClass: 'economy',
    });

    router.push(`/flight-results?${query.toString()}`);
  };

  return (
    <section className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground">Popular Routes</h2>
          <p className="text-sm text-muted-foreground mt-1">Trending destinations with the best fares this month</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {POPULAR_ROUTES.map((route) => (
          <button
            key={route.id}
            onClick={() => handleRouteClick(route)}
            className="group bg-card border border-border rounded-xl p-4 hover:border-primary hover:card-shadow-hover text-left transition-all duration-200 active:scale-98"
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-2xl">{route.flag}</span>
              <span className="text-xs font-semibold text-muted-foreground bg-muted px-2 py-1 rounded-full">
                Round trip
              </span>
            </div>
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-bold text-foreground">{route.from}</span>
              <svg className="w-4 h-4 text-muted-foreground flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
              <span className="text-sm font-bold text-foreground">{route.to}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-xs text-muted-foreground">{route.fromCode} → {route.toCode}</span>
            </div>
            <div className="mt-3 pt-3 border-t border-border flex items-center justify-between">
              <span className="text-xs text-muted-foreground">From</span>
              <span className="text-lg font-extrabold text-accent font-tabular">${route.price}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}